import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import Select from "../FormComponents/Select/Select";
import { parseISO, format } from "date-fns";
import moment from "moment";
import { usStates } from "../../utils/usStates";
import Modal from "react-bootstrap/Modal";
import Input from "../FormComponents/Input/Input";
import SelectDate from "../FormComponents/SelectDate/SelectDate";

const DriversQuote = (props) => {
	const { renewalId, renewalData, municipalities } = props;
	const [newDriver, setNewDriver] = useState(false);
	const [showEditDriver, setShowEditDriver] = useState(false);
	const [hideDriver, setHideDriver] = useState(null);
	const [driverPosition, setDriverPosition] = useState(0);
	const [municipalitiesOptions, setMunicipalitiesOptions] = useState([]);
	const [drivers, setDrivers] = useState([]);
	const [showModal, setShowModal] = useState(false);

	const dispatch = useDispatch();

	// Add Driver
	const [firstName, setFirstName] = useState("");
	const [lastName, setLastName] = useState("");
	const [birthDate, setBirthDate] = useState(null);
	const [email, setEmail] = useState("");
	const [phoneNumber, setPhoneNumber] = useState("");
	const [street, setStreet] = useState("");
	const [city, setCity] = useState("");
	const [state, setState] = useState("");
	const [zipCode, setZipCode] = useState("");
	const [municipality, setMunicipality] = useState("");
	const [relation, setRelation] = useState("");

	const firstNameRef = useRef();
	const lastNameRef = useRef();
	const emailRef = useRef();
	const streetRef = useRef();
	const cityRef = useRef();
	const stateRef = useRef();
	const zipCodeRef = useRef();
	const municipalityRef = useRef();
	const birthDateRef = useRef();

	const focusDriver = useRef();

	useEffect(() => {
		if (renewalData) {
			setDrivers(renewalData.drivers);
		}
	}, [renewalData]);

	const handleHideModal = () => {
		setShowModal(false);
	};

	const handleShowModal = (position) => {
		setDriverPosition(position);
		setShowModal(true);
	};

	const changeDrivers = (value) => {
		dispatch({
			type: "SET_LOADING_MONTHLY",
			payload: true,
		});
		const requestOptions = {
			method: "PUT",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ ...renewalData, drivers: value }),
		};
		fetch(`/api/v2/quotes/${renewalId}`, requestOptions)
			.then((response) => response.json())
			.then((data) => {
				dispatch({
					type: "SET_QUOTE_DATA",
					payload: data.quote,
				});
			});
	};
	useEffect(() => {
		if (municipalities) {
			let thisMunicipalities = JSON.parse(municipalities);
			thisMunicipalities = thisMunicipalities.map((municipality) => (
				<option value={municipality.id} key={municipality.id}>
					{municipality.municipality_name}
				</option>
			));
			setMunicipalitiesOptions(thisMunicipalities);
		}
	}, [municipalities]);

	const usStateOptions = usStates.map((state) => (
		<option value={state.value} key={state.value}>
			{state.name}
		</option>
	));

	const saveDriver = (e) => {
		e.preventDefault();
		if (!checkErrorsForm()) {
			const newDriver = {
				first_name: firstName,
				last_name: lastName,
				date_of_birth: birthDate,
				email: email,
				phone: phoneNumber,
				street: street,
				city: city,
				state: state,
				zip: zipCode,
				municipality: municipality,
				relation: relation,
			};
			setDrivers([...drivers, newDriver]);
			changeDrivers([...drivers, newDriver]);
			setNewDriver(false);
		}
	};

	const editedDriver = (e) => {
		e.preventDefault();
		if (!checkErrorsForm()) {
			//let newDrivers = drivers;
			let newDrivers = JSON.parse(JSON.stringify(drivers));
			const newDriver = {
				first_name: firstName,
				last_name: lastName,
				date_of_birth: birthDate,
				email: email,
				phone: phoneNumber,
				street: street,
				city: city,
				state: state,
				zip: zipCode,
				municipality: municipality,
				relation: relation,
			};
			newDrivers[driverPosition] = newDriver;
			setDrivers([...newDrivers]);
			changeDrivers([...newDrivers]);
			setShowEditDriver(false);
			setHideDriver(true);
		}
	};

	const removeDriver = () => {
		//let array = drivers;
		let array = JSON.parse(JSON.stringify(drivers));
		array.splice(driverPosition, 1);
		setDrivers(array);
		changeDrivers(array);
	};

	const checkErrorsForm = () => {
		let errors = false;
		let municipalityError = false;
		let relationError = false;

		const firstNameError = firstNameRef.current.validateInput();
		const lastNameError = lastNameRef.current.validateInput();
		const emailError = emailRef.current.validateInput();
		const streetError = streetRef.current.validateInput();
		const cityError = cityRef.current.validateInput();
		const zipCodeError = zipCodeRef.current.validateInput();
		const birthDateError = birthDateRef.current.validateInput();

		const stateError = stateRef.current.validateSelect();

		if (state === "KY") {
			municipalityError = municipalityRef.current.validateSelect();
		}
		/* if (driverPosition > 0) {
			relationError = relationRef.current.validateSelect();
		} */

		if (
			firstNameError ||
			lastNameError ||
			emailError ||
			streetError ||
			cityError ||
			zipCodeError ||
			stateError ||
			birthDateError
		) {
			errors = true;
		} else {
			if (state === "KY") {
				if (municipalityError) {
					errors = true;
				}
			}
			if (driverPosition > 0) {
				if (relationError) {
					errors = true;
				}
			}
		}
		return errors;
	};

	return (
		<div>
			<div className="col-12 ml-4 otmt-2">
				<h2>Drivers</h2>
			</div>
			{drivers.map((driver, i) => (
				<>
					<div key={i} className={`col-12 ${hideDriver === i ? "d-none" : ""}`}>
						<div className="mb-3 otmt-1 col">
							<div className="d-flex otmt-1">
								<div className="">
									<div className="d-flex">
										<div className="">
											<h2 className="circle pt-3 pt-md-2 text-center mb-0 text-uppercase">
												{driver.first_name.charAt(0)}
												{driver.last_name.charAt(0)}
											</h2>
										</div>
										<div className="col-8 col-sm-11 mt-3 mt-md-0 pl-3">
											<span className="mb-0 mt-0 h3" id="name">
												{driver.first_name}
											</span>
											<span className="ml-2 mb-0 mt-0 h3" id="last-name">
												{driver.last_name}
											</span>
											<p className="text-uppercase">{driver.relation}</p>
										</div>
										<div className="col col-sm-8 d-flex justify-content-end">
											<div>
												<button
													type="button"
													className="btn btn1"
													onClick={() => {
														setFirstName(driver.first_name);
														setLastName(driver.last_name);
														setBirthDate(driver.date_of_birth);
														setEmail(driver.email);
														setPhoneNumber(driver.phone);
														setStreet(driver.street);
														setCity(driver.city);
														setState(driver.state);
														setZipCode(driver.zip);
														setRelation(driver.relation);
														setShowEditDriver(true);
														setDriverPosition(i);
														setHideDriver(i);
													}}
												>
													EDIT
												</button>
											</div>
										</div>
									</div>
									<div className="col-12 d-lg-flex ml-5">
										<div className="col">
											<div className="">
												<p className="mb-1">
													{format(parseISO(driver.date_of_birth), "PPP")}
												</p>
												<p className="mb-1" id="e-mail">
													{driver.email}{" "}
												</p>
												<p className="mb-1">{driver.phone}</p>
												<p className="mb-1" id="the-city">
													{driver.street}
												</p>
												<p className="mb-1">
													<span id="the-city"> {driver.city}</span>,
													<span id="the-state"> {driver.state}</span>
													<span id="zip-code"> {driver.zip}</span>
												</p>
											</div>
											{driver.relation !== "primary" && (
												<div className="otmb-1 otmt-1 ">
													<p
														type="button"
														className="mb-0"
														style={{ color: "red" }}
														onClick={() => handleShowModal(i)}
													>
														<u>Remove this driver</u>
													</p>
												</div>
											)}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					{showEditDriver && (
						<div
							className={`col otmt-2 ${hideDriver === i ? "" : "d-none"}`}
							ref={focusDriver}
						>
							<div className="card mb-5">
								<div className="card-body col-11 mx-auto">
									<div className="d-flex justify-content-between otmb-2 otmt-1">
										<div className="">
											<h1 className="" style={{ color: "#00778a" }}>
												Edit Driver
											</h1>
										</div>
										<div className="">
											<i
												className="bi bi-x "
												onClick={() => {
													setHideDriver(true);
													setNewDriver(false);
												}}
											></i>
										</div>
									</div>
									<form onSubmit={(e) => editedDriver(e)}>
										<div>
											<div className="row">
												<div className="col-md-6">
													<Input
														val={firstName}
														setVal={setFirstName}
														label="FIRST NAME"
														classLabel="h5"
														classInput="form-control"
														validation="first_name"
														ref={firstNameRef}
													/>
												</div>
												<div className="col-md-6">
													<Input
														val={lastName}
														setVal={setLastName}
														label="LAST NAME"
														classLabel="h5"
														classInput="form-control"
														validation="last_name"
														ref={lastNameRef}
													/>
												</div>
											</div>

											<div className="d-block d-md-flex row">
												<div className="col-12 col-md-6">
													<Input
														val={email}
														setVal={setEmail}
														label="EMAIL ADDRESS"
														classLabel="h5"
														classInput="form-control"
														validation="email"
														ref={emailRef}
													/>
												</div>
												<div className="col-6 col-md-6 col-sm-5">
													<SelectDate
														val={
															birthDate
																? moment(birthDate).toDate()
																: moment().toDate()
														}
														classLabel="h5"
														setVal={setBirthDate}
														label="DATE OF BIRTH"
														validation="birthDate"
														ref={birthDateRef}
														maxDate={moment().subtract(25, "years").toDate()}
													/>
												</div>
											</div>
											{driverPosition > 0 && (
											<div className="row mt-3">
												<div className="col">
												<h5 className="">RELATIONSHIP TO PRIMARY DRIVER</h5>

												{drivers[0].relation === "spouse" ? (
													<div>
													<input
														required
														className="ml-2"
														type="radio"
														name="options"
														id="option2"
														checked={relation === "spouse"}
														key={1}
														onClick={() => setRelation("spouse")}
													/>
													<label htmlFor="option2" className="">
														<p className="ml-4 mt-2 radio">
														Spouse (included in Physical Damage and Liability policy)
														</p>
													</label>
													</div>
												) : (
													drivers.every((driver) => driver.relation !== "spouse") && (
													<div>
														<input
														required
														className="ml-2"
														type="radio"
														name="options"
														id="option2"
														checked={relation === "spouse"}
														key={1}
														onClick={() => setRelation("spouse")}
														/>
														<label htmlFor="option2" className="">
														<p className="ml-4 mt-2 radio">
															Spouse (included in Physical Damage and Liability policy)
														</p>
														</label>
													</div>
													)
												)}

												<div>
													<input
													required
													className="ml-2"
													type="radio"
													name="options"
													id="option3"
													checked={relation === "other"}
													key={2}
													onClick={() => setRelation("other")}
													/>
													<label htmlFor="option3" className="">
													<p className="ml-4 mt-2 radio">
														Other (only included in Physical Damage policy)
													</p>
													</label>
												</div>
												</div>
											</div>
											)}

											<div className="row otmt-2">
												<div className="col-md-6">
													<Input
														val={street}
														setVal={setStreet}
														label="STREET ADDRESS 1"
														classLabel="h5"
														classInput="form-control mb-md-3"
														validation="street"
														ref={streetRef}
													/>
												</div>
												<div className="col-md-6 ">
													<Input
														label="STREET ADDRESS 2"
														classLabel="h5"
														classInput="form-control mb-md-3"
													/>
												</div>
												<div className="col-md-6">
													<Input
														val={city}
														setVal={setCity}
														label="CITY"
														classLabel="h5"
														classInput="form-control"
														validation="city"
														ref={cityRef}
													/>
												</div>
												<div className="col mx-auto nopadding">
													<div className="col-md-6">
														<Select
															val={state}
															setVal={setState}
															label="STATE"
															options={usStateOptions}
															classLabel="h5"
															classSelect="custom-select form-control"
															validation="state"
															ref={stateRef}
														/>
													</div>

													<div className="col-md-6">
														<Input
															val={zipCode}
															setVal={setZipCode}
															label="ZIP CODE"
															classLabel="h5"
															classInput="form-control"
															validation="zipCode"
															ref={zipCodeRef}
														/>
													</div>
												</div>
												{state === "KY" && (
													<div className="col-md-6">
														<Select
															val={municipality}
															setVal={setMunicipality}
															label="MUNICIPALITY"
															selectLabel="Select Municipality"
															options={municipalitiesOptions}
															classLabel="h5"
															classSelect="custom-select form-control"
															validation="municipality"
															ref={municipalityRef}
														/>
													</div>
												)}
											</div>

											<div className="row">
												<div className="d-md-flex justify-content-md-end otmb-2">
													<div className="mr-md-4 otmt-2 otmb-1">
														<button
															type="button"
															className="col-12 btn btn1 btn-lg"
															onClick={() => {
																setNewDriver(false);
																setHideDriver(true);
																if (driverPosition != 0) {
																	setDriverPosition(driverPosition - 1);
																}
															}}
														>
															CANCEL
														</button>
													</div>
													<div className="otmt-2">
														<button
															type="submit"
															className="col-12 btn btn2 btn-lg"
														>
															EDIT DRIVER
														</button>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					)}
				</>
			))}
			{!newDriver && (
				<div className="col-12 d-flex justify-content-center otmt-2">
					<button
						type="button"
						id="carBtn"
						className="btn btn1 col-6"
						onClick={() => {
							setFirstName("");
							setLastName("");
							setBirthDate(null);
							setEmail("");
							setPhoneNumber("");
							setStreet("");
							setCity("");
							setState("");
							setZipCode("");
							setNewDriver(true);
							setDriverPosition(driverPosition + 1);
						}}
					>
						ADD A DRIVER
					</button>
				</div>
			)}
			{newDriver && (
				<div id="driverform" className="col otmt-2 " ref={focusDriver}>
					<div className="card mb-5">
						<div className="card-body col-11 mx-auto">
							<div className="d-flex justify-content-between otmb-2 otmt-1">
								<div className="">
									<h1 className="" style={{ color: "#00778a" }}>
										Add a Driver
									</h1>
								</div>
								<div className="">
									<i
										className="bi bi-x "
										onClick={() => {
											setHideDriver(true);
											setNewDriver(false);
										}}
									></i>
								</div>
							</div>
							<form onSubmit={(e) => saveDriver(e)}>
								<div>
									<div className="row">
										<div className="col-md-6">
											<Input
												val={firstName}
												setVal={setFirstName}
												label="FIRST NAME"
												classLabel="h5"
												classInput="form-control"
												validation="first_name"
												ref={firstNameRef}
											/>
										</div>
										<div className="col-md-6">
											<Input
												val={lastName}
												setVal={setLastName}
												label="LAST NAME"
												classLabel="h5"
												classInput="form-control"
												validation="last_name"
												ref={lastNameRef}
											/>
										</div>
									</div>

									<div className="d-block d-md-flex row">
										<div className="col-12 col-md-6">
											<Input
												val={email}
												setVal={setEmail}
												label="EMAIL ADDRESS"
												classLabel="h5"
												classInput="form-control"
												validation="email"
												ref={emailRef}
											/>
										</div>
										<div className="col-6 col-md-6 col-sm-5">
											<SelectDate
												val={
													birthDate
														? moment(birthDate).toDate()
														: moment().toDate()
												}
												classLabel="h5"
												setVal={setBirthDate}
												label="DATE OF BIRTH"
												validation="birthDate"
												ref={birthDateRef}
												maxDate={moment().subtract(25, "years").toDate()}
											/>
										</div>
									</div>
									{driverPosition > 0 && (
									<div className="row mt-3">
										<div className="col">
											<h5 className="">RELATIONSHIP TO PRIMARY DRIVER</h5>
											{drivers[0].relation === "spouse" ? (
												<div>
													<input
														required
														className="ml-2"
														type="radio"
														name="options"
														id="option2"
														checked={relation === "spouse"}
														key={1}
														onClick={() => setRelation("spouse")}
													/>
													<label htmlFor="option2" className="">
														<p className="ml-4 mt-2 radio">
															Spouse (included in Physical Damage and Liability policy)
														</p>
													</label>
												</div>
											) : (
												drivers.every(
													(driver) => driver.relation !== "spouse"
												) && (
													<div>
														<input
															required
															className="ml-2"
															type="radio"
															name="options"
															id="option2"
															checked={relation === "spouse"}
															key={1}
															onClick={() => setRelation("spouse")}
														/>
														<label htmlFor="option2" className="">
															<p className="ml-4 mt-2 radio">
																Spouse (included in Physical Damage and Liability policy)
															</p>
														</label>
													</div>
												)
											)}

											<div>
												<input
													required
													className="ml-2"
													type="radio"
													name="options"
													id="option3"
													checked={relation === "other"}
													key={2}
													onClick={() => setRelation("other")}
												/>
												<label htmlFor="option3" className="">
													<p className="ml-4 mt-2 radio">
														Other (only included in Physical Damage policy)
													</p>
												</label>
											</div>
										</div>
									</div>
								)}

									<div className="row otmt-2">
										<div className="col-md-6">
											<Input
												val={street}
												setVal={setStreet}
												label="STREET ADDRESS 1"
												classLabel="h5"
												classInput="form-control mb-md-3"
												validation="street"
												ref={streetRef}
											/>
										</div>
										<div className="col-md-6 ">
											<Input
												label="STREET ADDRESS 2"
												classLabel="h5"
												classInput="form-control mb-md-3"
											/>
										</div>
										<div className="col-md-6">
											<Input
												val={city}
												setVal={setCity}
												label="CITY"
												classLabel="h5"
												classInput="form-control"
												validation="city"
												ref={cityRef}
											/>
										</div>
										<div className="col mx-auto nopadding">
											<div className="col-md-6">
												<Select
													val={state}
													setVal={setState}
													label="STATE"
													options={usStateOptions}
													classLabel="h5"
													classSelect="custom-select form-control"
													validation="state"
													ref={stateRef}
												/>
											</div>

											<div className="col-md-6">
												<Input
													val={zipCode}
													setVal={setZipCode}
													label="ZIP CODE"
													classLabel="h5"
													classInput="form-control"
													validation="zipCode"
													ref={zipCodeRef}
												/>
											</div>
										</div>
										{state === "KY" && (
											<div className="col-md-6">
												<Select
													val={municipality}
													setVal={setMunicipality}
													label="MUNICIPALITY"
													selectLabel="Select Municipality"
													options={municipalitiesOptions}
													classLabel="h5"
													classSelect="custom-select form-control"
													validation="municipality"
													ref={municipalityRef}
												/>
											</div>
										)}
									</div>

									<div className="row">
										<div className="d-md-flex justify-content-md-end otmb-2">
											<div className="mr-md-4 otmt-2 otmb-1">
												<button
													type="button"
													className="col-12 btn btn1 btn-lg"
													onClick={() => {
														setNewDriver(false);
														setHideDriver(true);
														if (driverPosition != 0) {
															setDriverPosition(driverPosition - 1);
														}
													}}
												>
													CANCEL
												</button>
											</div>
											<div className="otmt-2">
												<button
													type="submit"
													className="col-12 btn btn2 btn-lg"
												>
													ADD DRIVER
												</button>
											</div>
										</div>
									</div>
								</div>
							</form>
						</div>
					</div>
				</div>
			)}

			<Modal
				className="cars-modal mx-auto"
				show={showModal}
				onHide={handleHideModal}
				centered
			>
				<div className="container">
					<div className="justify-content-md-center mx-auto">
						<div className="col-12 mt-4">
							<p className="t4">Are you sure you want to remove this driver?</p>
						</div>
					</div>

					<Modal.Footer>
						<div className="d-flex justify-content-between mt-4">
							<div className="col-5">
								<button onClick={handleHideModal} className="btn btn1">
									CANCEL
								</button>
							</div>
							<div className=" ">
								<button
									onClick={() => {
										removeDriver();
										handleHideModal();
									}}
									className="btn btn2"
								>
									CONFIRM REMOVAL
								</button>
							</div>
						</div>
					</Modal.Footer>
				</div>
			</Modal>
		</div>
	);
};

export default DriversQuote;
